import React from 'react';
import { Mail, Globe, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="py-12 px-4 bg-slate-950 text-white border-t border-slate-800" data-id="element-117">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-118">
        <div className="mb-8 bg-slate-900 p-6 rounded border border-slate-800 w-full max-w-md" data-id="element-119">
          <span className="text-electric font-black tracking-widest text-sm md:text-base uppercase bg-electric/10 px-4 py-2 rounded" data-id="element-120">
            MEGA KIT ELECTRICISTA PRO™
          </span>
          <p className="text-slate-400 text-xs md:text-sm mt-6 font-bold uppercase tracking-widest" data-id="element-121">
            MEGA KIT ELECTRICISTA PRO © 2026 | Edición LATAM
          </p>
        </div>

        <div className="flex gap-6 mb-10" data-id="element-122">
          <a href="#" className="w-12 h-12 bg-slate-900 rounded flex items-center justify-center text-slate-400 hover:text-electric hover:bg-slate-800 transition-all duration-300" data-id="element-123">
            <Instagram size={20} data-id="element-124" />
          </a>
          <a href="#" className="w-12 h-12 bg-slate-900 rounded flex items-center justify-center text-slate-400 hover:text-electric hover:bg-slate-800 transition-all duration-300" data-id="element-125">
            <Mail size={20} data-id="element-126" />
          </a>
          <a href="#" className="w-12 h-12 bg-slate-900 rounded flex items-center justify-center text-slate-400 hover:text-electric hover:bg-slate-800 transition-all duration-300" data-id="element-127">
            <Globe size={20} data-id="element-128" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-slate-500 font-semibold max-w-2xl leading-relaxed" data-id="element-129">
          <p data-id="element-130">
            El material es de carácter técnico y educativo. Los resultados
            pueden variar según la experiencia de cada persona, el contexto de
            trabajo, la normativa local vigente y el uso que se le dé al
            contenido. Se recomienda aplicar siempre las medidas de seguridad
            correspondientes y consultar la normativa eléctrica de cada país o
            localidad.
          </p>
        </div>
      </div>
    </footer>;
}